<template>
  <section class="pt-6 sm:pt-7 xl:pt-8 overflow-hidden">
    <div class="container lg:overflow-hidden">
      <h2 class="mb-4 md:mb-5 xl:mb-7 text-center">
        {{ t('read_more') }}
      </h2>
      <div class="row no-gutters ml-n2 sm:ml-n4 md:ml-n5 xl:ml-n6 mb-0">
        <ul
          class="media-other_catalog row mx-0 w-100 mb-0 flex-nowrap flex-grow-1 h-auto no-gutters mb-0 list-unstyled justify-center"
          data-carousel="media"
        >
          <li
            v-for="medium in media"
            :key="medium.id"
            class="flex flex-col col-6 md:col-5 lg:col-3"
          >
            <div class="pl-2 sm:pl-4 md:pl-5 xl:pl-6 flex flex-col flex-grow-1">
              <div class="product-item p-3 md:p-4 m-0 relative flex-grow-1">
                <RemoteResponsiveImage
                  v-if="medium.image"
                  :product-image-data="medium.image"
                  img-class="media-other_catalog-img"
                  :alt="medium.source"
                  sizes="(min-width: 1200px) 25vw, (min-width: 600px) 30vw, (min-width: 500px) 30vw, 50vw"
                />
                <RemoteImage
                  v-else
                  img-class="media-other_catalog-img"
                  :alt="medium.source"
                />
                <div class="pt-2 mb-n1 text-center text-lg medium-source">
                  <router-link
                    :to="{ name: 'mediaDetailPath', params: { permalink: medium.permalink } }"
                    class="product-item__title block stretched-link no-decoration font-medium"
                  >
                    {{ medium.source }}
                  </router-link>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <!-- ShowAll -->
      <div class="mt-5 lg:mt-6 text-center">
        <router-link
          :to="{ name: 'mediaPath' }"
          class="btn btn-success px-6 py-3  rounded-pill font-medium"
        >
          {{ t('show_all') }}
        </router-link>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useI18n } from 'vue-i18n'

import RemoteImage from '@/components/general/BaseRemoteImage.vue'
import RemoteResponsiveImage from '@/components/general/BaseRemoteResponsiveImage.vue'

const { t } = useI18n()
defineProps({
  media: {
    type: Array,
    required: true,
  },
})
</script>

<style lang="scss">
@include media-breakpoint-up(lg) {
	.overflow-lg-hidden { overflow: hidden !important; }
}
.media-other_catalog {
  &-img {
    width: 225px;
    height: 300px;
    object-fit: cover;
    object-position: top;
  }
}

@media (max-width: 1200px) {
  .media-other_catalog {
    &-img {
      width: 174px;
      height: 232px;
    }
  }
}

@media (max-width: 992px) {
  .media-other_catalog {
    &-img {
      width: 234px;
      height: 312px;
    }
  }
}

@media (max-width: 768px) {
  .media-other_catalog {
    &-img {
      width: 219px;
      height: 292px;
    }
  }
}

@media (max-width: 576px) {
  .media-other_catalog {
    &-img {
      width: 100%;
      height: 230px;
    }

    .medium-source {
      max-height: 60px;
      overflow: hidden;
    }
  }
}
</style>

<i18n>
  {
    "cs": {
    "read_more": "Číst další",
    "show_all": "Zobrazit všechny"
},
    "sk": {
    "read_more": "Čítať ďalšie",
    "show_all": "Zobraziť všetky"
},
    "pl": {
    "read_more": "Przeczytaj więcej",
    "show_all": "Zobacz wszystkie"
},
    "hu": {
    "read_more": "Mutass többet",
    "show_all": "Mutass mindent"
},
    "de": {
    "read_more": "Mehr lesen",
    "show_all": "Alle anzeigen"
},
    "at": {
    "read_more": "Mehr lesen",
    "show_all": "Alle anzeigen"
},
    "ro": {
    "read_more": "Citesc mai departe",
    "show_all": "Arată totul"
}
  }
</i18n>
